<mat-sidenav-container>
    <mat-sidenav #sidenav mode="side" position="end">
        <app-document-viewer (close)="toggleSlide(); documentLoadingUnsubscriber$.next();"
            [documentDetails]="selectedDocumentDetails"></app-document-viewer>
    </mat-sidenav>

    <mat-sidenav-content [class.opened]="isOpened">
        <div class="main-container lg-view">
            <div class="selection-list">
                <label *ngFor="let itemId of optionsKeys" class="selection-item"
                    [class.selected]="chosenItems.has(itemId)">

                    <input type="checkbox" (click)="toggleSelection(itemId)" [checked]="chosenItems.has(itemId)" />

                    <div class="item-description">
                        <input matInput [(ngModel)]="nameEditCollection.get(itemId).name"
                            [placeholder]="nameEditCollection.get(itemId).initialName"
                            [ngModelOptions]="{standalone: true}" />

                        <span class="details">Type:
                            {{ options.get(itemId).type }}</span>

                        <span class="details">Uploaded on:
                            {{ moment(options.get(itemId).createdOn).parseZone().format('MM/DD/YYYY') }}</span>
                    </div>

                    <div class="item-actions">
                        <button mat-flat-button (click)="showDocument(itemId, options.get(itemId).name)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </div>
                </label>
            </div>

            <div *ngIf="!options?.size" class="empty-message-container">There are no documents yet!</div>
        </div>

        <div class="actions-container md-view">
            <ng-container *ngIf="pageType === PageType.Customer">
                <ng-container
                    *ngIf="!customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
                    <action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [clickAction]="moveBack.bind(self)">
                    </action-button>
                    <action-button [icon]="ButtonIcons.Submit" [name]="'Submit'"
                        [clickAction]="submitSelection.bind(self)">
                    </action-button>
                </ng-container>

                <div class="actions-placeholder-message" *ngIf="customerPreferences.preferences.isNotificationDisabled || customerPreferences.preferences.isJobAutoSkipped">
                    <span
                        *ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
                        {{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
                    <span
                        *ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
                        {{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
                    <span
                        *ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
                        {{ ActionsPlaceholderSettings.BothDisabled }}</span>
                </div>

            </ng-container>

            <ng-container *ngIf="pageType !== PageType.Customer">
                <action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [clickAction]="moveBack.bind(self)">
                </action-button>
                <action-button [icon]="ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitSelection.bind(self)">
                </action-button>
            </ng-container>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>